import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = { class: "tab-head" }
const _hoisted_3 = { class: "tab-head-actions" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "filter-tabs" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_8 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_9 = {
  key: 2,
  class: "cards-grid"
}
const _hoisted_10 = ["onClick", "onKeydown"]
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = { class: "card-header-row" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-meta" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 0,
  class: "card-meta"
}
const _hoisted_17 = {
  key: 1,
  class: "card-justificativa"
}
const _hoisted_18 = { class: "card-row" }
const _hoisted_19 = {
  key: 0,
  class: "origin-chip",
  title: "Gerada automaticamente a partir de um relatório de campo"
}
const _hoisted_20 = {
  key: 1,
  class: "card-meta"
}
const _hoisted_21 = {
  key: 2,
  class: "card-value"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "page-shell"
}
const _hoisted_28 = { class: "page-topbar" }
const _hoisted_29 = { class: "page-topbar-actions" }
const _hoisted_30 = { class: "page-card" }
const _hoisted_31 = { class: "view-header" }
const _hoisted_32 = { class: "view-title" }
const _hoisted_33 = { class: "view-chips" }
const _hoisted_34 = {
  key: 0,
  class: "origin-chip",
  title: "Gerada automaticamente a partir de um relatório de campo"
}
const _hoisted_35 = { class: "meta-grid" }
const _hoisted_36 = { class: "meta-block" }
const _hoisted_37 = { class: "meta-value" }
const _hoisted_38 = { class: "meta-block" }
const _hoisted_39 = { class: "meta-value" }
const _hoisted_40 = { class: "meta-block" }
const _hoisted_41 = { class: "meta-value" }
const _hoisted_42 = { class: "meta-block" }
const _hoisted_43 = { class: "meta-value" }
const _hoisted_44 = { class: "meta-block" }
const _hoisted_45 = { class: "meta-value meta-value--strong" }
const _hoisted_46 = {
  key: 0,
  class: "view-section"
}
const _hoisted_47 = { class: "view-text" }
const _hoisted_48 = { class: "view-section" }
const _hoisted_49 = {
  key: 0,
  class: "items-empty-hint"
}
const _hoisted_50 = {
  key: 1,
  class: "items-empty-hint"
}
const _hoisted_51 = {
  key: 2,
  class: "items-table-wrap"
}
const _hoisted_52 = { class: "items-table" }
const _hoisted_53 = { class: "col-img" }
const _hoisted_54 = ["src", "onClick"]
const _hoisted_55 = { class: "cell-strong" }
const _hoisted_56 = ["href"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "col-num" }
const _hoisted_59 = { class: "col-num" }
const _hoisted_60 = { class: "col-num" }
const _hoisted_61 = { class: "col-num cell-strong" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = { class: "col-num cell-strong" }
const _hoisted_64 = {
  key: 2,
  class: "page-shell"
}
const _hoisted_65 = { class: "page-topbar" }
const _hoisted_66 = { class: "page-card" }
const _hoisted_67 = { class: "view-title form-page-title" }
const _hoisted_68 = { class: "form-grid" }
const _hoisted_69 = { class: "field field--full" }
const _hoisted_70 = { class: "field field--full" }
const _hoisted_71 = { class: "field" }
const _hoisted_72 = { class: "field" }
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "field field--full" }
const _hoisted_75 = ["value"]
const _hoisted_76 = { class: "items-section" }
const _hoisted_77 = { class: "items-header" }
const _hoisted_78 = {
  key: 0,
  class: "items-empty-hint"
}
const _hoisted_79 = {
  key: 0,
  class: "item-row item-row--head"
}
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = ["onUpdate:modelValue"]
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = ["onUpdate:modelValue"]
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = {
  key: 1,
  class: "items-empty-hint"
}
const _hoisted_88 = {
  key: 0,
  class: "form-error"
}
const _hoisted_89 = { class: "form-actions" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'list')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "tab-title" }, "Requisições de Compra", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "btn-secondary",
                type: "button",
                disabled: _ctx.exporting,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exportToExcel && _ctx.exportToExcel(...args)))
              }, [
                _cache[18] || (_cache[18] = _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2"
                }, [
                  _createElementVNode("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                  _createElementVNode("polyline", { points: "7 10 12 15 17 10" }),
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "15",
                    x2: "12",
                    y2: "3"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.exporting ? 'Exportando...' : 'Exportar'), 1)
              ], 8, _hoisted_4),
              _createElementVNode("button", {
                class: "btn-primary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openForm()))
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("svg", {
                  width: "13",
                  height: "13",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.2"
                }, [
                  _createElementVNode("line", {
                    x1: "12",
                    y1: "5",
                    x2: "12",
                    y2: "19"
                  }),
                  _createElementVNode("line", {
                    x1: "5",
                    y1: "12",
                    x2: "19",
                    y2: "12"
                  })
                ], -1),
                _createTextVNode(" Nova RC ", -1)
              ]))])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusFilters, (f) => {
              return (_openBlock(), _createElementBlock("button", {
                key: f.value,
                class: _normalizeClass(["filter-tab", { active: _ctx.statusFilter === f.value }]),
                type: "button",
                onClick: ($event: any) => (_ctx.statusFilter = f.value)
              }, _toDisplayString(f.label), 11, _hoisted_6))
            }), 128))
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Carregando..."))
            : (_ctx.filteredRcs.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("svg", {
                    width: "36",
                    height: "36",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "1.4"
                  }, [
                    _createElementVNode("path", { d: "M9 11l3 3L22 4" }),
                    _createElementVNode("path", { d: "M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" })
                  ], -1),
                  _createTextVNode(" Nenhuma requisição encontrada. ", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRcs, (rc) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: rc.id,
                      class: "rc-card",
                      role: "button",
                      tabindex: "0",
                      onClick: ($event: any) => (_ctx.openView(rc)),
                      onKeydown: _withKeys(($event: any) => (_ctx.openView(rc)), ["enter"])
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", _hoisted_13, _toDisplayString(rc.titulo), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["urgencia-badge", `urgencia--${rc.urgencia}`])
                          }, _toDisplayString(rc.urgencia), 3)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createTextVNode(_toDisplayString(_ctx.formatDate(rc.createdAt)), 1),
                          (rc.projectName)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " · " + _toDisplayString(rc.projectName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (rc.fornecedorNome)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Fornecedor: " + _toDisplayString(rc.fornecedorNome), 1))
                          : _createCommentVNode("", true),
                        (rc.justificativa)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(rc.justificativa), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["status-chip", _ctx.rcStatusClass(rc.status)])
                          }, _toDisplayString(_ctx.rcStatusLabel(rc.status)), 3),
                          (rc.sourceSubmissionId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "via relatório"))
                            : _createCommentVNode("", true),
                          (rc.itemCount)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(rc.itemCount) + " iten(s)", 1))
                            : _createCommentVNode("", true),
                          (rc.valorTotal)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.formatCurrency(rc.valorTotal)), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "card-footer",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("button", {
                          class: "card-btn card-btn--primary",
                          type: "button",
                          onClick: ($event: any) => (_ctx.openView(rc))
                        }, [...(_cache[22] || (_cache[22] = [
                          _createElementVNode("svg", {
                            width: "12",
                            height: "12",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2"
                          }, [
                            _createElementVNode("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "12",
                              r: "3"
                            })
                          ], -1),
                          _createTextVNode(" Visualizar ", -1)
                        ]))], 8, _hoisted_22),
                        (_ctx.canEdit(rc))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "card-btn",
                              type: "button",
                              onClick: ($event: any) => (_ctx.openForm(rc))
                            }, "Editar", 8, _hoisted_23))
                          : _createCommentVNode("", true),
                        (rc.status === 'rascunho')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "card-btn card-btn--primary",
                              type: "button",
                              onClick: ($event: any) => (_ctx.submit(rc.id))
                            }, "Enviar para aprovação", 8, _hoisted_24))
                          : _createCommentVNode("", true),
                        (rc.status === 'pendente')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              class: "card-btn card-btn--ok",
                              type: "button",
                              onClick: ($event: any) => (_ctx.respond(rc.id, 'approve'))
                            }, "Aprovar", 8, _hoisted_25))
                          : _createCommentVNode("", true),
                        (rc.status === 'pendente')
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 3,
                              class: "card-btn card-btn--warn",
                              type: "button",
                              onClick: ($event: any) => (_ctx.respond(rc.id, 'reject'))
                            }, "Reprovar", 8, _hoisted_26))
                          : _createCommentVNode("", true)
                      ])
                    ], 40, _hoisted_10))
                  }), 128))
                ]))
        ], 64))
      : (_ctx.mode === 'view' && _ctx.viewRc)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                class: "btn-back",
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
              }, [...(_cache[23] || (_cache[23] = [
                _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.2"
                }, [
                  _createElementVNode("line", {
                    x1: "19",
                    y1: "12",
                    x2: "5",
                    y2: "12"
                  }),
                  _createElementVNode("polyline", { points: "12 19 5 12 12 5" })
                ], -1),
                _createTextVNode(" Voltar ", -1)
              ]))]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.canEdit(_ctx.viewRc))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-secondary",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openForm(_ctx.viewRc)))
                    }, [...(_cache[24] || (_cache[24] = [
                      _createElementVNode("svg", {
                        width: "13",
                        height: "13",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2"
                      }, [
                        _createElementVNode("path", { d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" }),
                        _createElementVNode("path", { d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" })
                      ], -1),
                      _createTextVNode(" Editar ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_ctx.viewRc.status === 'rascunho')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn-primary",
                      type: "button",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit(_ctx.viewRc.id)))
                    }, "Enviar para aprovação"))
                  : _createCommentVNode("", true),
                (_ctx.viewRc.status === 'pendente')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      class: "btn-approve",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.respond(_ctx.viewRc.id, 'approve')))
                    }, "Aprovar"))
                  : _createCommentVNode("", true),
                (_ctx.viewRc.status === 'pendente')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 3,
                      class: "btn-reject",
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.respond(_ctx.viewRc.id, 'reject')))
                    }, "Reprovar"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h2", _hoisted_32, _toDisplayString(_ctx.viewRc.titulo), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["status-chip", _ctx.rcStatusClass(_ctx.viewRc.status)])
                  }, _toDisplayString(_ctx.rcStatusLabel(_ctx.viewRc.status)), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["urgencia-badge", `urgencia--${_ctx.viewRc.urgencia}`])
                  }, _toDisplayString(_ctx.viewRc.urgencia), 3),
                  (_ctx.viewRc.sourceSubmissionId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "via relatório"))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "meta-label" }, "Data de criação", -1)),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.formatDate(_ctx.viewRc.createdAt)), 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[26] || (_cache[26] = _createElementVNode("span", { class: "meta-label" }, "Obra", -1)),
                  _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.viewRc.projectName || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[27] || (_cache[27] = _createElementVNode("span", { class: "meta-label" }, "Fornecedor sugerido", -1)),
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.viewRc.fornecedorNome || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _cache[28] || (_cache[28] = _createElementVNode("span", { class: "meta-label" }, "Solicitante", -1)),
                  _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.viewRc.requestedBy || '—'), 1)
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _cache[29] || (_cache[29] = _createElementVNode("span", { class: "meta-label" }, "Valor total estimado", -1)),
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.viewItemsTotal ? _ctx.formatCurrency(_ctx.viewItemsTotal) : '—'), 1)
                ])
              ]),
              (_ctx.viewRc.justificativa)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "view-section-title" }, "Justificativa", -1)),
                    _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.viewRc.justificativa), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_48, [
                _cache[33] || (_cache[33] = _createElementVNode("h3", { class: "view-section-title" }, "Itens requisitados", -1)),
                (_ctx.viewLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, "Carregando itens..."))
                  : (_ctx.viewItems.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Nenhum item nesta requisição."))
                    : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("table", _hoisted_52, [
                          _cache[32] || (_cache[32] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "col-img" }),
                              _createElementVNode("th", null, "Item"),
                              _createElementVNode("th", null, "Descrição"),
                              _createElementVNode("th", null, "Link"),
                              _createElementVNode("th", { class: "col-num" }, "Qtd"),
                              _createElementVNode("th", { class: "col-num" }, "Un."),
                              _createElementVNode("th", { class: "col-num" }, "Valor unit. est."),
                              _createElementVNode("th", { class: "col-num" }, "Subtotal")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewItems, (item, idx) => {
                              return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                                _createElementVNode("td", _hoisted_53, [
                                  (item.imageUrl)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.resolveUrl(item.imageUrl),
                                        class: "item-thumb",
                                        alt: "",
                                        onClick: ($event: any) => (_ctx.openImage(item.imageUrl))
                                      }, null, 8, _hoisted_54))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_55, _toDisplayString(item.nome || item.descricao || '—'), 1),
                                _createElementVNode("td", null, _toDisplayString(item.nome ? (item.descricao || '—') : '—'), 1),
                                _createElementVNode("td", null, [
                                  (item.link)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        href: item.link,
                                        target: "_blank",
                                        rel: "noopener",
                                        class: "item-link"
                                      }, "abrir", 8, _hoisted_56))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_57, "—"))
                                ]),
                                _createElementVNode("td", _hoisted_58, _toDisplayString(item.quantidade), 1),
                                _createElementVNode("td", _hoisted_59, _toDisplayString(item.unidade || 'un'), 1),
                                _createElementVNode("td", _hoisted_60, _toDisplayString(item.valorUnitarioEstimado ? _ctx.formatCurrency(item.valorUnitarioEstimado) : '—'), 1),
                                _createElementVNode("td", _hoisted_61, _toDisplayString(item.valorUnitarioEstimado ? _ctx.formatCurrency(item.valorUnitarioEstimado * (item.quantidade || 1)) : '—'), 1)
                              ]))
                            }), 128))
                          ]),
                          (_ctx.viewItemsTotal)
                            ? (_openBlock(), _createElementBlock("tfoot", _hoisted_62, [
                                _createElementVNode("tr", null, [
                                  _cache[31] || (_cache[31] = _createElementVNode("td", {
                                    colspan: "7",
                                    class: "col-num cell-strong"
                                  }, "Total estimado", -1)),
                                  _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.formatCurrency(_ctx.viewItemsTotal)), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("button", {
                class: "btn-back",
                type: "button",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
              }, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("svg", {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2.2"
                }, [
                  _createElementVNode("line", {
                    x1: "19",
                    y1: "12",
                    x2: "5",
                    y2: "12"
                  }),
                  _createElementVNode("polyline", { points: "12 19 5 12 12 5" })
                ], -1),
                _createTextVNode(" Voltar ", -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("h2", _hoisted_67, _toDisplayString(_ctx.editId ? 'Editar Requisição' : 'Nova Requisição de Compra'), 1),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("label", _hoisted_69, [
                  _cache[35] || (_cache[35] = _createElementVNode("span", { class: "field-label" }, "Título *", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "field-input",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.titulo) = $event)),
                    placeholder: "Descreva brevemente a necessidade"
                  }, null, 512), [
                    [_vModelText, _ctx.form.titulo]
                  ])
                ]),
                _createElementVNode("label", _hoisted_70, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "field-label" }, "Justificativa", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    class: "field-input field-textarea",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.justificativa) = $event)),
                    rows: "2",
                    placeholder: "Por que esta compra é necessária?"
                  }, null, 512), [
                    [_vModelText, _ctx.form.justificativa]
                  ])
                ]),
                _createElementVNode("label", _hoisted_71, [
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "field-label" }, "Urgência", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "field-input",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.urgencia) = $event))
                  }, [...(_cache[37] || (_cache[37] = [
                    _createElementVNode("option", { value: "normal" }, "Normal", -1),
                    _createElementVNode("option", { value: "alta" }, "Alta", -1),
                    _createElementVNode("option", { value: "urgente" }, "Urgente", -1)
                  ]))], 512), [
                    [_vModelSelect, _ctx.form.urgencia]
                  ])
                ]),
                _createElementVNode("label", _hoisted_72, [
                  _cache[40] || (_cache[40] = _createElementVNode("span", { class: "field-label" }, "Obra", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "field-input",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.projectId) = $event))
                  }, [
                    _cache[39] || (_cache[39] = _createElementVNode("option", { value: "" }, "Selecione...", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: p.id,
                        value: p.id
                      }, _toDisplayString(p.name), 9, _hoisted_73))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.projectId]
                  ])
                ]),
                _createElementVNode("label", _hoisted_74, [
                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "field-label" }, "Fornecedor Sugerido", -1)),
                  _withDirectives(_createElementVNode("select", {
                    class: "field-input",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.fornecedorId) = $event))
                  }, [
                    _cache[41] || (_cache[41] = _createElementVNode("option", { value: "" }, "Nenhum", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliers, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.id,
                        value: s.id
                      }, _toDisplayString(s.nomeFantasia || s.razaoSocial), 9, _hoisted_75))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.form.fornecedorId]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", { class: "items-title" }, "Itens", -1)),
                  _createElementVNode("button", {
                    class: "btn-add-item",
                    type: "button",
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.addItem && _ctx.addItem(...args)))
                  }, "+ Adicionar item")
                ]),
                (_ctx.formItemsLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, "Carregando itens..."))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.form.items.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [...(_cache[44] || (_cache[44] = [
                            _createElementVNode("span", null, "Item", -1),
                            _createElementVNode("span", null, "Descrição", -1),
                            _createElementVNode("span", null, "Link", -1),
                            _createElementVNode("span", null, "Qtd", -1),
                            _createElementVNode("span", null, "Un.", -1),
                            _createElementVNode("span", null, "Valor est.", -1),
                            _createElementVNode("span", null, null, -1)
                          ]))]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.items, (item, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: "item-row"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input item-desc",
                            "onUpdate:modelValue": ($event: any) => ((item.nome) = $event),
                            placeholder: "Nome do item"
                          }, null, 8, _hoisted_80), [
                            [_vModelText, item.nome]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input item-desc",
                            "onUpdate:modelValue": ($event: any) => ((item.descricao) = $event),
                            placeholder: "Descrição / detalhes"
                          }, null, 8, _hoisted_81), [
                            [_vModelText, item.descricao]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input item-desc",
                            "onUpdate:modelValue": ($event: any) => ((item.link) = $event),
                            placeholder: "Link (opcional)"
                          }, null, 8, _hoisted_82), [
                            [_vModelText, item.link]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input item-qty",
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((item.quantidade) = $event),
                            min: "1",
                            placeholder: "Qtd"
                          }, null, 8, _hoisted_83), [
                            [
                              _vModelText,
                              item.quantidade,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input item-unit",
                            "onUpdate:modelValue": ($event: any) => ((item.unidade) = $event),
                            placeholder: "Un."
                          }, null, 8, _hoisted_84), [
                            [_vModelText, item.unidade]
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            class: "field-input item-value",
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((item.valorUnitarioEstimado) = $event),
                            min: "0",
                            step: "0.01",
                            placeholder: "Valor est."
                          }, null, 8, _hoisted_85), [
                            [
                              _vModelText,
                              item.valorUnitarioEstimado,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("button", {
                            class: "btn-remove-item",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removeItem(idx))
                          }, "✕", 8, _hoisted_86)
                        ]))
                      }), 128)),
                      (_ctx.form.items.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_87, "Nenhum item adicionado."))
                        : _createCommentVNode("", true)
                    ], 64))
              ]),
              (_ctx.formError)
                ? (_openBlock(), _createElementBlock("p", _hoisted_88, _toDisplayString(_ctx.formError), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("button", {
                  class: "btn-save",
                  type: "button",
                  disabled: _ctx.saving,
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                }, _toDisplayString(_ctx.saving ? 'Salvando...' : (_ctx.editId ? 'Salvar Alterações' : 'Salvar Rascunho')), 9, _hoisted_90),
                _createElementVNode("button", {
                  class: "btn-cancel",
                  type: "button",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
                }, "Cancelar")
              ])
            ])
          ])),
    (_ctx.lightboxUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "lightbox",
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.lightboxUrl = ''))
        }, [
          _createElementVNode("img", {
            src: _ctx.lightboxUrl,
            alt: ""
          }, null, 8, _hoisted_91)
        ]))
      : _createCommentVNode("", true)
  ]))
}